"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      cursor: "pointer"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.handleImgClick.apply(null, arguments);
      }
    }
  }, [_vm.isImageFile ? _c("img", {
    staticClass: "!w-[60px] !h-[60px] object-cover",
    attrs: {
      src: _vm.filePath
    }
  }) : _c("div", {
    staticClass: "flex w-[60px] h-[60px] bg-[#3975c6] items-center justify-around bg-brand-primary text-white text-lg aspect-square",
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.handleClick.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.fileExtension) + " ")]), _c("a-modal", {
    on: {
      ok: function ($event) {
        _vm.visible = false;
      },
      cancel: function ($event) {
        _vm.visible = false;
      }
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("img", {
    staticClass: "w-full h-full object-cover",
    attrs: {
      src: _vm.filePath
    }
  })])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;